import { createTableColumns } from './tableConfig';
import { Table } from 'components/shared/Table';
import { UserProfile } from 'types';

interface Props {
  tableData?: UserProfile[];
}

export const ContactsTable = ({ tableData }: Props) => {
  const columns = createTableColumns();

  return (
    <Table<UserProfile>
      tableData={tableData || []}
      columns={columns}
      paginationOptions={{
        pageSize: 5,
      }}
    />
  );
};
